export default function AboutSection(){

  return <>
    <div className="aboutText">
      <h2>Who is Monster Basket?</h2>
      Hi! I'm James.  James Montero-Blaskett.
      <br/><span style={{"fontStyle": "italic"}}>(I'll animate my name to swap between that and Monster Basket)</span>
      <br/><br/>
      It's not quite as complicated as "I am Lord Voldemort", but that's where the name comes from.  And come on, isn't it great!?  I'm a gamer, a husband, a dad, annnnd that's about it.  I completed a Bachelor's Degree in animation a life-time ago, bored myself to death in a large corporation for a decade, then did a career change to software engineer a few years ago.  I started making websites for some extra cash, but I'm good at it, so now it's all I do!
    </div>
    <div className="aboutPic"></div>
  </>
}